import { render } from "./CustomeFavoriteProducts.vue?vue&type=template&id=2dcd862b&scoped=true&ts=true"
import script from "./CustomeFavoriteProducts.vue?vue&type=script&lang=ts"
export * from "./CustomeFavoriteProducts.vue?vue&type=script&lang=ts"

import "./CustomeFavoriteProducts.vue?vue&type=style&index=0&id=2dcd862b&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcd862b"]])

export default __exports__